/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { FunctionComponent, useEffect, useState, useRef } from 'react';
import MultiSelectorItem from './MultiSelectorItem/MultiSeletorItem';
import DropDown from '../../Compound/DropDown/DropDown';
import Button from '../Button/Button';
import Icon from '../../DataDisplay/Icon/Icon';
import ErrorText from '../../Text/ErrorText/ErrorText';
import styles from './MultiSelector.module.scss';

export type ItemProps = {
  label: string;
  value: string;
  checked: boolean;
  isReadOnly?: boolean;
  isDisabled?: boolean;
  isLocked?: boolean;
};

export type MultiSelectorProps = {
  id?: string;
  variant?: 'multi' | 'outline' | 'outlined';
  name: string;

  value?: string;
  isActive?: boolean;
  items?: ItemProps[];
  labelPosition?: 'left' | 'right';
  labelSize?: string;
  height?: string;
  minHeight?: string;
  minWidth?: string;
  identifier?: string;
  indicatorMinHeight?: string;

  borderColor?: string;
  hasSelectAll?: boolean;
  selectAllLabel?: string;
  isDisabled?: boolean;
  disabledLabel?: string;
  itemHeight?: string;
  borderRadius?: string;
  borderWidth?: string;
  color?: string;
  addNewStyle?: 'standard' | 'bolded';
  // eslint-disable-next-line @typescript-eslint/ban-types
  style?: object;
  allowNew?: boolean;
  newTitle?: string;
  nosort?: boolean;
  placeholder?: string;
  error?: string | string[] | null;
  lockedItemContact?: () => void;
  disabled?: boolean;
  setFieldValue: (field: string, value: string) => void;
  onClose?: (values: string) => void;
  useStateValues?: boolean;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  isSelectAll?: boolean;
  selectAllName?: string;
};

type FC = FunctionComponent<MultiSelectorProps>;

const MultiSelector: FC = ({
  variant = 'multi',
  name,
  value,
  isActive,
  disabled,
  items,
  labelPosition = 'left',
  labelSize,
  height,
  minHeight,
  minWidth,
  identifier,
  indicatorMinHeight,
  borderColor,
  hasSelectAll,
  selectAllLabel,
  selectAllName = 'Select All',
  isDisabled = false,
  disabledLabel,
  itemHeight,
  borderRadius,
  borderWidth,
  color,
  style,
  allowNew = false,
  newTitle,
  addNewStyle = 'standard',
  nosort = false,
  placeholder,
  isSelectAll,
  setFieldValue,
  onClose = () => {},
  error = null,
  lockedItemContact = () => {},
  onBlur,
}: MultiSelectorProps) => {
  const boxRef = useRef<HTMLDivElement>(null);
  const wordListRef = useRef<HTMLSpanElement>(null);
  const [multiItems, setMultiItems] = useState<ItemProps[]>([]);
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [itemsUpdated, setItemsUpdated] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState('');
  const [selectAll, setSelectAll] = useState(false);
  const [topPosition, setTopPosition] = useState('');
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    if (items && items?.length > 0) {
      setMultiItems(items);
      setItemsUpdated(true);
    }
  }, [items]);

  useEffect(() => {
    if (itemsUpdated) {
      setItemsUpdated(false);
      const selectItems = multiItems;
      const sortedItems = nosort
        ? (selectItems ?? [])
        : (selectItems ?? []).slice().sort((a, b) => a.label.localeCompare(b.label));

      const updatedMultiItems = hasSelectAll
        ? [
            {
              label: selectAllLabel || '',
              value: selectAllLabel || '',
              checked: sortedItems.every((item) => item.checked),
              isDisabled: false,
              isReadOnly: false,
            },
            ...sortedItems,
          ]
        : sortedItems;
      setMultiItems(updatedMultiItems);
    }
  }, [itemsUpdated, multiItems, hasSelectAll, selectAllLabel]);

  // update selected label
  useEffect(() => {
    const labels = [];
    const selectedLabels = value?.split('|') || [];

    // Check if all labels have been found, if not, add missing labels
    for (const item of multiItems) {
      if (selectedLabels.includes(item.value)) {
        labels.push(item.label);
      }
    }
    if (value === 'new') {
      setSelectedLabel(newTitle || 'New');
    } else {
      setSelectedLabel(labels?.join('; ') || '');
    }
  }, [value, multiItems]);

  // dropdown position
  useEffect(() => {
    const updatePosition = () => {
      if (boxRef.current) {
        const boxHeight = boxRef.current.clientHeight;
        setTopPosition(`${boxHeight + 8}px`);
      }
    };

    updatePosition();
    window.addEventListener('resize', updatePosition);

    return () => {
      window.removeEventListener('resize', updatePosition);
    };
  }, [boxRef?.current?.clientHeight]);

  const onClickNew = () => {
    const updatedMultiItems = [...(multiItems || [])].map((item) => ({ ...item, checked: false }));
    setMultiItems(updatedMultiItems);

    setFieldValue(name, 'new');
    setIsMenuVisible(false);
  };

  useEffect(() => {
    if (!isMenuVisible && isInitialized) {
      const checkedValues = multiItems
        .filter((item) => item.checked && item.isLocked !== true)
        .map((item) => item.value)
        .join('|');
      onClose(checkedValues ?? '');
    } else {
      setIsInitialized(true);
    }
  }, [isMenuVisible]);
  useEffect(() => {
    const allItemsChecked = (multiItems || []).every((item) => item.checked);
    setSelectAll(allItemsChecked);
  }, [multiItems]);

  const handleItemCheck = (idx: number, isChecked: boolean) => {
    const updatedMultiItems = [...(multiItems || [])];

    if (hasSelectAll) {
      if (idx === 0) {
        // toggle checkboxes when clicking on the 'Select All' option
        const updatedMultiItems = multiItems?.map((item) => ({
          ...item,
          checked: isChecked,
        }));
        setMultiItems(updatedMultiItems);
        const checkedValues = (updatedMultiItems || [])
          .filter((item) => item.checked && item.isLocked !== true && item.label !== selectAllLabel)
          .map((item) => item.value)
          .join('|');

        setFieldValue(name, checkedValues);
      } else {
        if (!isChecked) {
          updatedMultiItems[0].checked = false;
          updatedMultiItems[idx].checked = false;
        } else {
          updatedMultiItems[idx].checked = isChecked;
        }
        // set the 'Select All' option to true when all other checkboxes are selected
        const hasUnSelectedItems = updatedMultiItems.find(
          (item) => item.label !== selectAllLabel && item.checked === false,
        );
        const allSelectedItems = multiItems?.map((item) => ({
          ...item,
          checked: true,
        }));

        setMultiItems(hasUnSelectedItems ? updatedMultiItems : allSelectedItems);

        const checkedValues = updatedMultiItems
          .filter((item) => item.checked && item.isLocked !== true)
          .map((item) => item.value)
          .join('|');

        setFieldValue(name, checkedValues);
      }
    } else {
      updatedMultiItems[idx].checked = isChecked;
      setMultiItems(updatedMultiItems);

      const checkedValues = updatedMultiItems
        .filter((item) => item.checked && item.isLocked !== true)
        .map((item) => item.value)
        .join('|');

      setFieldValue(name, checkedValues);
    }
  };

  const handlerBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    onBlur(event);
  };
  const [labelWidth, setLabelWidth] = useState(0);
  useEffect(() => {
    if (boxRef.current) {
      setLabelWidth(boxRef.current?.clientWidth - 57); // Adjusting for padding/border/margins
    }
    const updateWidth = () => {
      if (boxRef.current) {
        const newWidth = boxRef.current?.clientWidth - 57; // Adjusting for padding/border/margins
        setLabelWidth(newWidth);
      }
    };

    updateWidth();

    const handleResize = () => {
      updateWidth();
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [boxRef.current?.clientWidth]); // Re-calculate when multiItems change

  useEffect(() => {
    if (wordListRef.current) {
      wordListRef.current.scrollLeft = wordListRef.current.scrollWidth - wordListRef.current.clientWidth;
    }
  }, [selectedLabel, wordListRef.current, wordListRef.current?.scrollWidth, wordListRef.current?.clientWidth]);
  const [page, setPage] = useState(1);
  useEffect(() => {
    let pageInner = 1;
    const intervalId = setInterval(() => {
      if (pageInner * 500 > multiItems.length) {
        clearInterval(intervalId);

        return;
      }
      pageInner += 1;
      setPage(pageInner);
    }, 200);
    return () => {
      clearInterval(intervalId);
    };
  }, [multiItems.length]);

  return (
    <>
      <div
        ref={boxRef}
        className={[
          styles.multiSelectBox,
          styles[variant],
          styles[getActiveClass()],
          styles[getDisabledClass()],
          styles[getErrorClass(error)],
        ].join(' ')}
        onBlur={handlerBlur}
        style={{ ...style, height, minHeight, minWidth, borderColor, borderRadius, borderWidth, color }}
      >
        <DropDown
          label={
            <span className={styles.labelContainer} style={{ width: labelWidth }}>
              <span className={styles.labelList} ref={wordListRef}>
                {isDisabled ? disabledLabel : selectedLabel === '' && placeholder ? placeholder : selectedLabel}
              </span>
            </span>
          }
          fontColor={selectedLabel === '' && placeholder ? '#747474' : undefined}
          variant="multi"
          maxHeight="200px"
          disabled={disabled}
          isMenuVisible={isMenuVisible}
          topPosition={topPosition}
          indicatorMinHeight={indicatorMinHeight}
          onClick={!isDisabled ? setIsMenuVisible : () => {}}
        >
          {isSelectAll && (
            <MultiSelectorItem
              key="MultiSelector-all"
              idx={1000000}
              label={selectAllName}
              isChecked={selectAll}
              labelPosition={labelPosition}
              labelSize={labelSize}
              identifier={identifier}
              onClick={(_idx, isChecked) => {
                const updatedArray = (multiItems || []).map((item) => ({
                  ...item,
                  checked: isChecked,
                }));
                setMultiItems(updatedArray);
                const selectedLabelsValues = updatedArray
                  .filter((item) => item.checked)
                  .map((item) => item.value)
                  .join('; ');
                const checkedValues = updatedArray
                  .filter((item) => item.checked && item.isLocked !== true)
                  .map((item) => item.value)
                  .join('|');
                setFieldValue(name, checkedValues);
                setSelectedLabel(selectedLabelsValues);
                setSelectAll(isChecked);
              }}
            />
          )}
          {allowNew && (
            <div
              className={[styles.itemContainer, styles[addNewStyle]].join(' ')}
              onClick={() => {
                onClickNew();
              }}
            >
              {addNewStyle === 'bolded' && <Icon icon="add" height="20px" width="20px" />} {'  '} {newTitle || 'New'}
            </div>
          )}
          {multiItems
            ?.slice(0, page * 500)
            .map(({ label, checked, isReadOnly, isDisabled, isLocked }, idx) => (
              <MultiSelectorItem
                key={`MultiSelector-${idx}`}
                idx={idx}
                label={label}
                isChecked={checked}
                isDisabled={isDisabled}
                isReadOnly={isReadOnly}
                isLocked={isLocked}
                labelPosition={labelPosition}
                labelSize={labelSize}
                identifier={identifier}
                itemHeight={itemHeight}
                lockedItemContact={lockedItemContact}
                onClick={handleItemCheck}
              />
            ))}
        </DropDown>
        <div className={styles.iconContainer}>
          <Button
            id="open-multi-select"
            label=""
            background="transparent"
            noShadow
            noPadding
            size="sm"
            icon="angleDown"
            iconSize="xsm"
            color="secondary"
            iconLocation="center"
            isCircle
            onClick={() => {
              setIsMenuVisible(!isMenuVisible);
            }}
          />
        </div>
      </div>
      <ErrorText error={error} size="sm" indentation />
    </>
  );

  function getActiveClass() {
    return isActive ? 'active' : '';
  }
  function getErrorClass(errorString: string | string[] | null | undefined) {
    return errorString !== null && errorString ? 'error' : '';
  }

  function getDisabledClass() {
    return isDisabled ? 'disabled' : '';
  }
};

export default MultiSelector;
